import { CircleIcon, TwoFactorIcon } from "common/Icons"
import FormSetTwoFactor from "./components/form"


const MobileSetTwoFactor = () => {
    return (
        <div className='bg-L-gray-50 h-[100vh] inset-0 relative'>

            <div>
                <div className="absolute top-[-126px] right-[-184px]">
                    <CircleIcon width={372} height={283} />
                </div>
                <div className='flex justify-center pt-8 z-10 relative'>
                    <TwoFactorIcon width={135} height={135} />
                </div>
            </div>

            <FormSetTwoFactor />
        </div>
    )
}


export default MobileSetTwoFactor